<template>
  <div class="py-4 d-flex align-items-center justify-content-between flex-wrap">
    <form class="d-flex flex-wrap">
      <!-- unit1 field -->
      <div class="form-field">
        <label class="form-field__label">{{ translations('dashboard.unit_1') }}</label>

        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ translations(`dashboard.${filter.unit1.title}`) }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              v-for="unit in computedUnits1"
              :key="unit.key"
              class="dropdown-item"
              @click="handleClickUnit1Item(unit)"
            >
              {{ unit.title }}
            </a>
          </div>
        </div>

        <!-- detail unit1 field -->
        <div class="form-group ml-1 mb-0">
          <input
            type='text'
            class='form-control'
            @change="changeSearch"
            name=selectedDetailUnit1
            :placeholder="translations('common.keyword_search')">
        </div>
      </div>

      <!-- unit2 field -->
      <div class="form-field">
        <label class="form-field__label">{{ translations('dashboard.unit_2') }}</label>

        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ translations(`dashboard.${filter.unit2.title}`) }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              v-for="unit in computedUnits2"
              :key="unit.key"
              class="dropdown-item"
              @click="handleClickUnit2Item(unit)"
            >
              {{ unit.title }}
            </a>
          </div>
        </div>

        <!-- detail unit2 field -->
        <div class="form-group ml-1 mb-0">
          <input
            type='text'
            class='form-control'
            @change="changeSearch"
            name=selectedDetailUnit2
            :disabled="isUnitNull"
            :placeholder="translations('common.keyword_search')">
        </div>
      </div>

      <!-- startAt - endAt field -->
      <div class="form-field">
        <label class="form-field__label">{{ translations('dashboard.period') }}</label>

        <DatePicker
          v-model="filter.dateRange"
          value-type="format"
          format="YYYY/MM/DD"
          placeholder="yyyy/mm/dd ~ yyyy/mm/dd"
          class="date-range-field"
          range
          :clearable="false"
        />
      </div>

      <!-- conditions -->
      <div class="form-field">
        <div
          class="mr-3"
          v-for="condition in translatedConditions"
          :key="condition.value"
        >
          <label class="custom-radio-button mb-0 d-flex align-items-center">
            <input
              v-model="filter.condition"
              type="radio"
              name="condition"
              :value="condition.value"
            />
            <span class="mb-0 ml-2">{{ condition.label }}</span>
          </label>
        </div>
        <div class="form-inline d-flex flex-wrap input-all">
          <div class="form-group">
            <label class="pointer-clickable">
              <input id='displayAll' v-model="filter.displayAll" type="checkbox" class="form-control mr-1 pointer-clickable">
              <span>{{ translations('dashboard.display_all') }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group mt-2">
        <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
      </div>
    </form>

    <button
      type="button"
      class="btn btn-sm btn-link p-0 decoration-underline"
      :disabled="disabledCsvDownload"
      @click="$emit('click-csv-download')"
    >
      {{translations('dashboard.csv_download') }}
    </button>
  </div>
</template>

<script>
import { format } from 'date-fns'

import DatePicker from '@/components/common/DatePicker'

import { CONDITIONS_INVENTORY } from '../../constants'
import { mapState } from 'vuex'

const UNITS1 = [
  { key: 'product', title: '商品' },
  { key: 'customer', title: '顧客' },
  { key: 'supplier', title: '仕入先' },
  { key: 'category', title: 'カテゴリ' },
  { key: 'employee', title: '担当者' }
]

const UNITS2 = {
  product: [
    { key: 'customer', title: '顧客' },
    { key: 'employee', title: '担当者' }
  ],
  customer: [
    { key: '', title: 'NULL' },
    { key: 'product', title: '商品' },
    { key: 'supplier', title: '仕入先' },
    { key: 'category', title: 'カテゴリ' },
    { key: 'employee', title: '担当者' }
  ],
  supplier: [
    { key: '', title: 'NULL' },
    { key: 'product', title: '商品' },
    { key: 'customer', title: '顧客' },
    { key: 'category', title: 'カテゴリ' },
    { key: 'employee', title: '担当者' }
  ],
  category: [
    { key: 'product', title: '商品' },
    { key: 'customer', title: '顧客' },
    { key: 'supplier', title: '仕入先' },
    { key: 'employee', title: '担当者' }
  ],
  employee: [
    { key: 'product', title: '商品' },
    { key: 'customer', title: '顧客' },
    { key: 'supplier', title: '仕入先' },
    { key: 'category', title: 'カテゴリ' }
  ]
}

export default {
  name: 'ArchiveSummarySalesFilter',

  components: { DatePicker },

  props: {
    value: { type: Object, default: () => ({}) },
    disabledCsvDownload: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      filter: {
        condition: CONDITIONS_INVENTORY.good.value,
        unit1: UNITS1[0],
        unit2: UNITS2.product[0],
        dateRange: [
          format(new Date(new Date().getFullYear(), 0, 1), 'yyyy/MM/dd'),
          format(new Date(), 'yyyy/MM/dd')
        ],
        selectedDetailUnit1: null,
        selectedDetailUnit2: null,
        displayAll: false
      },
      CONDITIONS_INVENTORY,
      noOptionResultText: 'データが見つかりません。',
      loadingMoreText: '読み込み中',
      detailOptionsUnit1: [],
      detailOptionsUnit2: [],
      observer: null,
      productMetaData: {
        limit: 10,
        total: 0,
        page: 1
      },
      products: [],
      textSearchProduct: '',
      isLoadingProducts: false,
      search: false
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    computedUnits1 () {
      return UNITS1.filter((unit) => unit.key !== this.filter.unit1.key).map(unit => ({
        ...unit,
        title: this.translations(`dashboard.${unit.key}`)
      }))
    },
    computedUnits2 () {
      return UNITS2[this.filter.unit1.key]
        .filter(unit => unit.key !== this.filter.unit2.key)
        .map(unit => ({
          ...unit,
          title: unit.key === '' ? 'NULL' : this.translations(`dashboard.${unit.key}`)
        }))
    },
    isUnitNull () {
      return this.filter.unit2.key === ''
    },
    translatedConditions () {
      return Object.keys(this.CONDITIONS_INVENTORY).map(key => {
        const condition = this.CONDITIONS_INVENTORY[key]
        return {
          label: this.translations(`dashboard.${condition.value}`),
          value: condition.value
        }
      })
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    changeSearch (e) {
      const { value, name } = e.target
      this.filter[name] = value
    },

    resetProductData () {
      this.textSearchProduct = ''
      this.products = []
      this.productMetaData = {
        limit: 10,
        total: 0,
        page: 1
      }
    },

    handleClickUnit1Item (unit) {
      const { unit2 } = this.filter
      const hasCurrentUnit2InUnit1 = UNITS2[unit.key].find(
        (unit) => unit.key === this.filter.unit2.key
      )

      this.resetProductData()
      this.filter = {
        ...this.filter,
        unit1: unit,
        /*
         * Reset unit2 when:
         * - The selected unit 1 matches the current unit 2
         * or Options of unit2  are not available when selecting unit 1
         */
        unit2:
          unit.key === unit2.key || !hasCurrentUnit2InUnit1
            ? UNITS2[unit.key][0]
            : unit2,
        selectedDetailUnit1: null,
        selectedDetailUnit2: null
      }
    },

    handleClickUnit2Item (unit) {
      /*
       * 1. Reset product data when key of unit is product
       * 2. Reset detail unit 2
       */
      if (unit.key === 'product') {
        this.resetProductData()
      }
      this.filter = {
        ...this.filter,
        unit2: unit,
        selectedDetailUnit2: null
      }
    },

    mappingDetailOptions (options = [], key) {
      if (key === 'category') {
        return options
          .reduce((prevVal, newVal) => [...prevVal, ...newVal.libs], [])
          .map((option) => ({ id: option.id, label: option.name }))
      }

      if (key === 'employee') {
        return options.map((option) => ({ id: option.id, label: option.name }))
      }

      if (key === 'customer') {
        return options.map((option) => ({
          id: option.id,
          label: option.company
        }))
      }

      if (key === 'supplier') {
        return options.map((option) => ({ id: option.id, label: option.name }))
      }

      if (key === 'product') {
        return options.map((option) => ({
          id: option.id,
          label: option.product_code
        }))
      }
    },

    submitSearch () {
      this.search = true
      this.$emit('get-search', this.search)
    }
  },

  watch: {
    filter: {
      handler (newFilter) {
        this.$emit('input', newFilter)
      },
      deep: true,
      immediate: true
    }
  },

  created () {
    this.$emit('get-search', this.search)
  }
}
</script>

<style scoped>
.filter-form {
  display: flex;
}

.form-field {
  display: flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 10px;
}

.form-field__label {
  margin-bottom: 0px;
  margin-right: 10px;
}

.date-range-field {
  width: 215px;
}

.custom-radio-button {
  cursor: pointer;
}

/* Begin - custom v-select */
.custom-v-select {
  width: 150px !important;
}

.custom-v-select__loading-more {
  text-align: center;
}

.custom-v-select >>> .vs__dropdown-toggle {
  width: 100%;
  min-width: 0;
}

.custom-v-select >>> .vs__selected-options {
  flex: 1;
  min-width: 0;
  align-items: center;
}

.custom-v-select >>> .vs__selected {
  display: block;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  min-width: 0;
  color: #6c757d;
}

.custom-v-select.vs--open >>> .vs__selected {
  display: none;
}

.custom-v-select >>> .vs--single.vs--open .vs__selected {
  display: none;
}

.custom-v-select >>> .vs__search {
  flex-grow: 0;
}

.custom-v-select.vs--open >>> ul {
  border-top-style: solid;
  border-radius: 4px;
  min-width: 100%;
}

.custom-v-select >>> .vs__open-indicator {
  transform: scale(0.7);
  color: #6c757d;
}

.custom-v-select >>> .vs__search {
  padding: 0 1px;
}

.custom-v-select >>> .vs__search:focus {
  padding: 0 10px;
}

.custom-v-select >>> .vs__dropdown-option {
  color: #6c757d;
}

.custom-v-select >>> .vs__dropdown-option--highlight {
  background: #f5f5f5;
  color: #6c757d;
}

.disabled-v-select >>> .vs__search {
  display: none;
}

.v-select.vs--searchable.disabled-v-select >>> .vs__dropdown-toggle {
  background-color: #e9ecef;
}
/* End - custom v-select */
</style>
